import React from 'react';
import { Clock4, RefreshCw, Star } from 'lucide-react';
import { guidelinesData } from '../mock/programsData';

const cardStyles = [
  { Icon: Clock4, accent: 'text-pink-600', border: 'border-pink-300', chip: 'from-pink-200 to-pink-300' },
  { Icon: RefreshCw, accent: 'text-purple-600', border: 'border-purple-300', chip: 'from-purple-200 to-purple-300' },
  { Icon: Star, accent: 'text-yellow-700', border: 'border-yellow-400', chip: 'from-yellow-200 to-yellow-300' }
];

const Guidelines = () => {
  return (
    <section
      id="guidelines"
      data-testid="guidelines-section"
      className="py-20 bg-gradient-to-br from-yellow-50 via-pink-50 to-blue-50"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            {guidelinesData.title}
          </h2>
          <p className="text-base md:text-lg text-purple-600 max-w-2xl mx-auto">
            {guidelinesData.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {guidelinesData.items.map((item, i) => {
            const { Icon, accent, border, chip } = cardStyles[i % cardStyles.length];
            return (
              <div
                key={item.title}
                data-testid={`guideline-${i}`}
                className={`bg-white border-3 ${border} rounded-3xl p-7 hover:shadow-xl transition-all duration-300`}
              >
                <div className={`w-12 h-12 bg-gradient-to-br ${chip} rounded-2xl flex items-center justify-center mb-4`}>
                  <Icon className={`h-6 w-6 ${accent}`} />
                </div>
                <h3 className={`text-lg font-bold ${accent} mb-3`}>{item.title}</h3>
                <div className="space-y-2.5">
                  {item.lines.map((line, idx) => (
                    <p key={idx} className="text-sm text-gray-700 leading-relaxed">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Guidelines;
